// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-Pyt","content":"styles_content__1Oych","row":"styles_row__3Smry","footer":"styles_footer__1qywx","phraseLength":"styles_phraseLength__1uIYb"};